export const CareerOfferComponent = {
	transclude: true,
	bindings: {
		qoutation: '<'
	},
	templateUrl: 'career-offer.html',
	controller: class CareerOfferComponent {
		constructor() {
		}

		$onChanges(changes) {
			if (changes.qoutation) {
				this.idezet = this.qoutation;
			}
		}

		goToCareerPage($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
		}
	}
};
